import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule }
	from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'copo-dialog-ecall-off',
	templateUrl: './dialog-ecall-off.component.html',
	styleUrl: './dialog-ecall-off.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [MatDialogModule, TranslateModule, MatButtonModule]
})
export class DialogEcallOffComponent implements OnInit {
	millTobeUnselected?: string;
	constructor(

		@Inject(MAT_DIALOG_DATA) public data: unknown,

		private readonly dialogRef: MatDialogRef<DialogEcallOffComponent>
	) {}

	ngOnInit() {
		this.dialogRef.updateSize('60%');
		this.dialogRef.disableClose = true;
	}

	cancel() {
		this.dialogRef.close(false);
	}

	validate() {
		this.dialogRef.close(true);
	}
}
